$(function () {
	heroVideoControl();
});

function heroVideoControl() {
	let video = $(".hero-item video");
	let poster = $(".hero-item .poster");
	let playBtn = $(".btn-hero-play");

	playBtn.on("click", function () {
		if (video[0].muted) {
			video[0].muted = false;
			$(this).find("em").removeClass("fa-volume").addClass("fa-volume-mute");
		} else {
			video[0].muted = true;
			$(this).find("em").removeClass("fa-volume-mute").addClass("fa-volume");
		}
	});
}